import React from "react";
import "./smallProductCard.scss";
import { Link } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";

const SmallProductCardSkeleton = ({ height }) => {
  return (
    <Box className="small-single-product">
      <Box component="div" className="product-image">
        <Link className="link" style={{ height: height }}>
          <Skeleton animation="wave" variant="rectangular" component="img" />
        </Link>
      </Box>
      <div className="product-basic-details">
        <Link className="link">
          <Skeleton animation="wave">
            <p className="product-title">Product Title</p>
          </Skeleton>
          <div className="product-price">
            <Skeleton animation="wave">
              <p>₹2520</p>
            </Skeleton>
          </div>
        </Link>
      </div>
    </Box>
  );
};

export default SmallProductCardSkeleton;
